import React from "react";
import ComingSoon from "../../../subComponents/ComingSoon";

const Events = () => {
  return <ComingSoon />;
};

export default Events;
